import React, { Component } from 'react';
import axios from 'axios';
import { Footer } from './components/common/page/Footer';
import { Auth } from './components/auth/Auth';
import { Vote } from './components/vote/Vote';
import { LoadingPanel } from './components/common/LoadingPanel'

import './tailwind.css'
import './custom.css'

export default class App extends Component {
    state = {
        // Auth states
        isAuthInit: false,
        isAuthLogin: false,
        isAuthReceipt: false,
        isAuthPersonalId: false,
        isPreview: false,

        // Authenticated voter
        voter: null,
        ballot: null,
        validateState: null,
        isValidatedAdmin: false,

        // Auth inputs
        voterId: null,
        voterGuid: null,
        ballotId: null,
        receipt: null,
        personalId: null,
        previewId: null,
        bioId: null,
        shortCode: null
    }

    componentDidMount() {
        let shortCode, ballotId, previewId, voterId, voterGuid, receipt, personalId = null

        // Check for short code URL
        const path = window.location.pathname
        const pathParts = path.split("/")
        if (pathParts[1] === "v") {
            shortCode = pathParts[2]
            this.setState({ shortCode })
        }
        // Check URL params
        else {
            const urlParams = new URLSearchParams(window.location.search);

            // Set ballot ID if supplied
            ballotId = urlParams.get('b')
            this.setState({ ballotId })

            // Set preview ID if supplied
            previewId = urlParams.get('preview')
            this.setState({ previewId })

            // Set biography ID if supplied
            this.setState({ bioId: urlParams.get('bio') })

            // Get voter auth details if supplied
            voterId = urlParams.get('id')
            this.setState({ voterId })
            voterGuid = urlParams.get('key')
            this.setState({ voterGuid })
            receipt = urlParams.get('receipt')
            this.setState({ receipt })
            personalId = urlParams.get('pId')
            this.setState({ personalId })
        }

        // Attempt URL auth
        if (voterId && voterGuid) {
            this.authVoter(voterId, voterGuid, receipt, personalId, previewId)
        }
        // Attempt short code
        else if (shortCode) {
            this.authShortCode(shortCode)
        }
        // Attempt preview auth
        else if (ballotId && previewId) {
            this.authPreview(ballotId, previewId)
        }
        // If ballot ID then retrieve details for customised login screen
        else if (ballotId) {
            this.getBallotForLogin(ballotId)
        }
        else {
            this.setState({ isAuthInit: true })
            this.setState({ isAuthLogin: true })
        }
    }

    getBallotForLogin = (ballotId) => {
        axios.post('/auth/ballot', {
            ballotId: ballotId
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    this.setState({ ballot: response.data.payload })
                }
                else {
                    this.setState({ authError: response.data.errorMessage })
                }

                // Regardless of outcome show login screen
                this.setState({ isAuthInit: true })
                this.setState({ isAuthLogin: true })
            })
            .catch(function (error) {
                alert(error)
            })
    }

    onUpdateAuth = (voter, ballot, validateState) => {
        this.setState({ voter })
        this.setState({ ballot })
        this.setState({ validateState })
    }

    /**
     * URL link authorisation
     * @param {any} voterId Voter unique ID
     * @param {any} voterGuid Voter GUID
     * @param {any} receipt Optional receipt
     * @param {any} onComplete Optional onComplete closure
     */
    authVoter = (voterId, voterGuid, receipt, personalId, previewId, onComplete) => {
        axios.post('/auth/voter', {
            id: voterId,
            key: voterGuid,
            receipt: receipt,
            personalId: personalId,
            previewId: previewId
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    this.handleAuthResponse(response.data.payload)
                }
                else {
                    this.setState({ authError: response.data.errorMessage })
                    this.setState({ isAuthInit: true })
                    this.setState({ isAuthLogin: true })
                }

                if (onComplete) {
                    onComplete(response.data.payload?.validateState)
                }
            })
            .catch(function (error) {
                alert(error)
            })
    }

    /**
     * Preview authorisation
     * @param {any} ballotId Ballot ID
     * @param {any} previewId Preview ID
     * @param {any} onComplete Optional onComplete closure
     */
    authPreview = (ballotId, previewId, onComplete) => {
        axios.post('/auth/preview', {
            ballotId: parseInt(ballotId),
            previewId: previewId
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    this.setState({ isPreview: true })
                    this.handleAuthResponse(response.data.payload)
                }
                else {
                    this.setState({ authError: response.data.errorMessage })
                }

                if (onComplete) {
                    onComplete()
                }
            })
            .catch(function (error) {
                alert(error)
            })
    }

    /**
     * Short code authorisation
     * @param {any} shortCode Short code
     * @param {any} onComplete Optional onComplete closure
     */
    authShortCode = (shortCode, onComplete) => {
        axios.post('/auth/short', {
            shortCode: shortCode
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    // Capture ID and guid as these don't come from URL query params
                    let authView = response.data.payload
                    this.setState({ voterId: authView.voter.uniqueId })
                    this.setState({ voterGuid: authView.voter.guid })
                    this.handleAuthResponse(authView)
                }
                else {
                    this.setState({ authError: response.data.errorMessage })
                }

                if (onComplete) {
                    onComplete()
                }
            })
            .catch(function (error) {
                alert(error)
            })
    }

    handleAuthResponse = (authView) => {
        const voter = authView.voter
        const ballot = authView.ballot
        const validateState = authView.validateState
        const isValidatedAdmin = authView.isValidatedAdmin

        // Set page title to ballot
        document.title = ballot.name;

        this.setState({ voter })
        this.setState({ ballot })
        this.setState({ isValidatedAdmin })
        this.setState({ validateState })

        // Update auth states
        this.setState({ isAuthReceipt: validateState === "ReceiptRequired" || validateState === "ReceiptInvalid" })
        this.setState({ isAuthPersonalId: validateState === "PersonalIdRequired" || validateState === "PersonalIdInvalid" })
        this.setState({ isAuthLogin: false })

        let authError = null
        if (validateState === "ReceiptInvalid") {
            authError = "The receipt supplied is invalid"
        }
        if (validateState === "PersonalIdInvalid") {
            const personalIdLabel = ballot && ballot.personalIdLabel ? ballot.personalIdLabel : "Personal ID"
            authError = `The ${personalIdLabel} supplied is invalid`
        }
        this.setState({ authError })

        // Set mounted to show local components
        this.setState({ isAuthInit: true })
    }

    handleUpdateAuth = (onComplete = null) => {
        this.authVoter(this.state.voterId, this.state.voterGuid, this.state.receipt,
            this.state.personalId, this.state.previewId, onComplete)
    }

    onValidateReceipt = (receipt, onComplete) => {
        this.setState({ receipt })
        this.authVoter(this.state.voterId, this.state.voterGuid, receipt,
            this.state.personalId, this.state.previewId, onComplete)
    }

    onValidatePersonalId = (personalId, onComplete) => {
        this.setState({ personalId })
        this.authVoter(this.state.voterId, this.state.voterGuid, this.state.receipt,
            personalId, this.state.previewId, onComplete)
    }

    onValidateLogin = (voterId, password, onComplete) => {
        this.setState({ voterId })

        axios.post('/auth/login', {
            id: voterId,
            password: password
        })
            .then((response) => {
                if (response.data.isSuccessful) {
                    // Reload the page with credential URL
                    const voter = response.data.payload.voter
                    window.location.search = `id=${voter.uniqueId}&key=${voter.guid}`
                }
                else {
                    this.setState({ authError: response.data.errorMessage })
                }

                onComplete()
            })
            .catch(function (error) {
                alert(error)
            })
    }

    content() {
        if (this.state.isAuthLogin || this.state.isAuthReceipt || this.state.isAuthPersonalId) {
            return <Auth
                isAuthReceipt={this.state.isAuthReceipt}
                isAuthPersonalId={this.state.isAuthPersonalId}
                authError={this.state.authError}
                onValidateReceipt={this.onValidateReceipt}
                onValidatePersonalId={this.onValidatePersonalId}
                onValidateLogin={this.onValidateLogin}
                ballot={this.state.ballot} />;
        }
        else if (this.state.voter && this.state.ballot) {
            return (
                <div className="bg-white py-8 px-10 shadow sm:rounded-lg sm:mt-8">
                    <Vote
                        voter={this.state.voter}
                        ballot={this.state.ballot}
                        validateState={this.state.validateState}
                        isPreview={this.state.isPreview}
                        previewId={this.state.previewId}
                        bioId={this.state.bioId}
                        isValidatedAdmin={this.state.isValidatedAdmin}
                        onUpdateAuth={this.handleUpdateAuth}
                    />
                </div>
            );
        }
    }

    render() {
        return (
            <div className="container" role="main">
                <LoadingPanel className="bg-white py-8 px-10 shadow sm:rounded-lg sm:mt-8 text-center"
                    isLoading={!this.state.isAuthInit}
                    loadingText="Loading Ballot..."
                />
                {
                    this.content()
                }
                <Footer />
            </div >
        );
    }
}